/* eslint-env browser */

const productTileHelper = require('./helpers/productTile');

/**
 * Decorates the slot and its children with Constructor data attributes.
 * @param {Element} slot - The recommendation container
 */
const decorateConstructorItems = (slot) => {
  if (!slot || slot.hasAttribute('data-cnstrc-recommendations')) return;

  const items = slot.querySelectorAll('.product-detail__tile-row__item');
  if (items.length === 0) return;

  const podId = slot.id ? slot.id.replace('cq_recomm_slot-', '') : null;

  slot.setAttribute('data-cnstrc-recommendations', '');
  slot.setAttribute('data-cnstrc-num-results', items.length);
  if (podId) {
    slot.setAttribute('data-cnstrc-recommendations-pod-id', podId);
  }

  items.forEach((itemContainer) => {
    const tile = itemContainer.querySelector('.product-tile');
    if (!tile) return;

    const trackingDataRaw = tile.getAttribute('data-tracking');
    if (!trackingDataRaw) return;

    try {
      const tracking = JSON.parse(trackingDataRaw);
      const pData = tracking.item || {};

      // Set Constructor specific attributes
      tile.setAttribute('data-cnstrc-item', 'recommendation');
      tile.setAttribute('data-cnstrc-item-id', pData.group_id || pData.id);
      tile.setAttribute('data-cnstrc-item-name', pData.name);
      tile.setAttribute('data-cnstrc-item-variation-id', pData.id);
      tile.setAttribute('data-cnstrc-item-price', pData.price);
      tile.setAttribute('data-cnstrc-item-section', 'Products');

      productTileHelper.syncBtnAttrs(tile);
    } catch (e) {
      window.console.warn('Constructor: Failed to parse item data', e);
    }
  });
};

/**
 * Initializes the observer to watch for dynamic recommendation loads.
 */
const initConstructorTracking = () => {
  const observer = new MutationObserver(() => {
    const selectors = [
      '[id^="cq_recomm_slot"]',
      '.style_with_product_recs_container',
      '.tfg-recommendations',
    ].join(',');

    const slots = document.querySelectorAll(selectors);
    if (slots && slots.length > 0) {
      slots.forEach((slot) => {
        if (slot) {
          decorateConstructorItems(slot);
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

function initRecommendationEvents() {
  document.addEventListener('tile:overlay-toggle', (e) => {
    const detail = e.detail || {};
    if (detail.shown && detail.tile) {
      productTileHelper.bindPLPSizeSelection(detail.tile);
    }
  });
}

module.exports = function () {
  initConstructorTracking();
  initRecommendationEvents();
};
